import fonts from './theme/fonts'

export const pxToRemPure = px => px / fonts.baseFontSize
export const pxToRem = px => `${px / fonts.baseFontSize}rem`

export const getHexColorWithOpacity = (color, opacity) => {
  const opacityPercent = Math.round(opacity * 100) / 100
  const alpha = Math.round(opacityPercent * 255)
  let hex = alpha.toString(16).toUpperCase()
  if (hex.length == 1) hex = '0' + hex

  return `${color}${hex}`
}

// Note: Only support hex code with 6 char length
export function hexToRgba(color, alpha) {
  const [r, g, b] = color.match(/\w\w/g).map(x => parseInt(x, 16))
  return `rgba(${r},${g},${b},${alpha})`
}
